import { Filterer } from "./table-filter-select";
import { TableController } from "./table";
import { GlobalTableConstants } from "./table-constants";

/** ###TypeDocName:sd-column### */
export class TableColumnBinding {
  /** The column header display label. */
  public label = "@";

  /**The field to get from the data object to be displayed in this column. i.e. 'owner.name' or 'name' */
  public field = "@";

  /**The id representation of the column. Defaults to using the field if not specified. */
  public id = "@?";

  /** Default width of the column in pixels. Defaults to 100. */
  public width = "@?";

  /** true/false Whether the column is displayed or not. */
  public hidden = "<?";

  /** true/false Whether the column is filterable or not. If no "filterer" is specified, this will assume string data.*/
  public isFilterable = "<?";

  /** Filterer object which is used to provide custom data type filtration capability. Of type Controls.Table.Filterer, defaulting to the StringFilterer. */
  public filterer = "<?";

  /** The horizontal alignment type on table cell. */
  public horizontalAlignment = "@?";

  /** The vertical alignment type on table cell. */
  public verticalAlignment = "@?";

  /** A comaparator to sort this column.  Parameters '{ o1: any, o2: any }' are passed to the function, and [-1, 0, 1] should be returned based on the comparison of the elements.*/
  public sortComparator = "&?";

  /** The formatter to apply on cell data under this column when exporting. type: (cellValue: string) => string */
  public exportFormatter = "<";

  /**
   * When true, all cells will automatically update their values when the data changes.
   * This will not adjust the sorting/filtering of the table.
   * Setting this to true may have performance impacts on large tables.
   */
  public useAutoUpdateCellRenderer = "@?";

  /** Whether to suppress auto width on column when autoFit is set on table. Default is false */
  public suppressAutoFit = "<?";
}

export type HorizontalAlignmentType = "left" | "center" | "right";
export type VerticalAlignmentType = "bottom" | "center" | "top";

export class ColumnController {
  public horizontalAlignment: HorizontalAlignmentType;
  public verticalAlignment: VerticalAlignmentType;
  public hidden: boolean;
  public label: string;
  public field: string;
  public defaultFilterValues: any[];
  public filterer: Filterer;
  public width: number;
  public useAutoUpdateCellRenderer: boolean;
  public isFilterable: boolean;
  public id: string;
  public biId: string;
  public exportFormatter: (cellValue: string) => string;
  public sortComparator: (obj: any) => number;
  public suppressAutoFit: boolean;
  // @ngInject
  constructor(public $scope: ng.IScope, public tableConstants: GlobalTableConstants) {}
}

export let columnCompileFn = function (
  $element: JQuery,
  $attrs: ng.IAttributes,
  compileTransclude: ng.ITranscludeFunction
) {
  return {
    post: function (
      scope: ng.IScope,
      element: JQuery,
      attrs: ng.IAttributes,
      ctrl: [TableController, ColumnController],
      transclude: any
    ) {
      const cellRenderTypeCustom = 0;
      const cellRenderTypeAUTO = 1;
      let customRender: any = undefined;
      let [tableController, columnController] = ctrl;
      if (transclude.isSlotFilled("cellTemplate")) {
        customRender = cellRenderTypeCustom;
      } else if (
        columnController.useAutoUpdateCellRenderer &&
        (<any>columnController.useAutoUpdateCellRenderer).toLowerCase() == "true"
      ) {
        customRender = cellRenderTypeAUTO;
      }
      tableController.addColumnData(columnController, customRender, compileTransclude);

      // watch hidden to know if we should call gridAPI to hide/show column.
      scope.$watch(
        function (scope: any) {
          return columnController.hidden;
        },
        function () {
          let isHidden: boolean = columnController.hidden ? columnController.hidden : false;
          tableController.updateColumnVisibility(columnController.field, !isHidden);
        }
      );
    }
  };
};
export function sdColumn(): ng.IDirective {
  return {
    scope: {},
    bindToController: <any>new TableColumnBinding(),
    restrict: "E",
    require: ["^sdTable", "sdColumn"],
    controller: ColumnController,
    compile: columnCompileFn,
    controllerAs: "sdTableColumnController",
    transclude: {
      cellTemplate: "?sdColumnTemplate"
    }
  };
}
